import moment from 'moment';
import { Invoice } from "./Billing";

export class GiftCard {
  constructor(data) {
    var self = this;
    self.type = "GiftCard";

    self.rootvm = data.rootvm;

    self.gift_card_uuid = ko.observable(data.gift_card_uuid);
    self.code = ko.observable(data.code);
    self.email = ko.observable(data.email);

    self.redeemer_uuid = ko.observable(data.redeemer_uuid);

    self.redeemed_amount = ko.observable(data.redeemed_amount);
    self.language = ko.observable(data.language);
    self.mongo_db_id = ko.observable(data.mongo_db_id);

    self.gift_amount = ko.observable(data.gift_amount);
    self.gift_card_status = ko.observable(data.status);
    self.pdf_path = ko.observable(data.pdf_path);
    self.invoice_name = ko.observable(data.invoice_name);
    self.invoice_address = ko.observable(data.invoice_address);
    self.invoice_phone = ko.observable(data.invoice_phone);
    self.shipping_name = ko.observable(data.shipping_name);
    self.shipping_address = ko.observable(data.shipping_address);
    self.mango_payin_id = ko.observable(data.mango_payin_id);
    self.payment_method = ko.observable(data.payment_method);
    self.expiration_date = ko.observable(data.expiration_date);
    self.currency = ko.observable(data.currency);
    self.product_type = ko.observable(data.product_type);

    self.extras = ko.observableArray([]);
    self.invoice = ko.observable();

    if (data.invoice) {
      self.invoice(new Invoice(data.invoice));
    }
    self.redeemed_invoices = ko.observableArray([]);

    if (data.redeemed_invoices) {
      self.redeemed_invoices(
        ko.utils.arrayMap(data.redeemed_invoices || [], function (x) {
          x.rootvm = data.rootvm;
          return new Invoice(x);
        })
      );
    }

    self.image_path_de = ko.observable(data.image_path_de);
    self.image_path_en = ko.observable(data.image_path_en);

    self.visible = ko.observable(data.visible);

    self.inserted = ko.observable(new moment(data.inserted));

    // How many times has it been used
    self.toggle_deactivate = function (deactivated) {
      return $.ajax({
        url: "/api/admin/discount-code/toggle-deactivated",
        type: "POST",
        data: ko.toJSON({
          deactivated: deactivated,
          g_uuid: self.gift_card_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.deactivated(deactivated);
            notyf.success("Toggled!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);
    self.editing_extra_notes = ko.observable(false);
    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/gift-card/extra-notes",
        type: "POST",
        data: ko.toJSON({
          gift_card_uuid: self.gift_card_uuid(),
          extra_notes: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.extra_notes);
            self.new_extra_notes(data.extra_notes);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.lookup_invoices = function () {
      // we need to add in a filter as well..
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/gift-card/invoices",
        type: "GET",
        data: {
          gift_card_uuid: self.gift_card_uuid(),
        },

        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.redeemed_invoices(
            ko.utils.arrayMap(
              data.gift_card.redeemed_invoices || [],
              function (x) {
                x.rootvm = self.rootvm;
                return new Invoice(x);
              }
            )
          );

          var inv = data.gift_card.invoice;
          if (inv) {
            inv.rootvm = self.rootvm;
            self.invoice(new Invoice(inv));
          }

          self.extras(
            ko.utils.arrayMap(data.gift_card.extras || [], function (x) {
              x.rootvm = self.rootvm;
              return new GiftCardExtra(x);
            })
          );
        },
        error: function (data) {
          self.error(data.statusText);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.gc_type = ko.observable(data.gc_type);

    self.pretty_gc_type = ko.pureComputed(function () {
      if (self.gc_type() == "GIFTCARD") {
        return "GC";
      } else {
        return "DC";
      }
    });

    self.selected_language_image = ko.pureComputed(function () {
      return self.image_path_de();
    });
  }
}

export class UsedGiftCard {
  constructor(data) {
    var self = this;
    self.type = "UsedGiftCard";

    self.amount_used = ko.observable(data.amount_used);
    self.invoice_number = ko.observable(data.invoice_number);
    self.code = ko.observable(data.code);
    self.gc_type = ko.observable(data.gc_type);

    self.pretty_gc_type = ko.pureComputed(function () {
      if (self.gc_type() == "GIFTCARD") {
        return "GC";
      } else {
        return "DC";
      }
    });
  }
}

export class GiftCardExtra {
  constructor(data) {
    var self = this;
    self.type = "GiftCardExtra";

    self.rootvm = data.rootvm;

    self.amount = ko.observable(data.amount);
    self.title = ko.observable(data.title);
  }
}

export class DiscountCode {
  constructor(data) {
    var self = this;
    self.type = "DiscountCode";

    self.rootvm = data.rootvm;

    self.discount_code_uuid = ko.observable(data.discount_code_uuid);
    self.code = ko.observable(data.code);
    self.discount_amount = ko.observable(data.discount_amount);
    self.expiration_date = ko.observable(data.expiration_date);
    self.minimum_amount = ko.observable(data.minimum_amount);
    self.currency = ko.observable(data.currency);
    self.can_use_pass_the_hat = ko.observable(data.can_use_pass_the_hat);

    self.image = ko.observable(data.visible);

    self.image_path_de = ko.observable(data.image_path_de);
    self.image_path_en = ko.observable(data.image_path_en);

    self.visible = ko.observable(data.visible);
    self.deactivated = ko.observable(data.deactivated);

    self.redeemed_invoices = ko.observableArray([]);

    self.inserted = ko.observable(new moment(data.inserted));

    // How many times has it been used
    self.uses_count = ko.observable(data.uses_count);

    if (self.uses_count() === undefined) {
      self.uses_count(0);
    }

    self.pretty_discount_amount = ko.pureComputed(function () {
      return self.discount_amount() + " " + self.currency();
    });

    self.selected_language_image = ko.pureComputed(function () {
      return self.image_path_de();
    });

    self.toggle_deactivate = function (deactivated) {
      return $.ajax({
        url: "/api/admin/discount-code/toggle-deactivated",
        type: "POST",
        data: ko.toJSON({
          deactivated: deactivated,
          discount_code_uuid: self.discount_code_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.deactivated(deactivated);
            notyf.success("Toggled!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.toggle_visible = function (visible) {
      return $.ajax({
        url: "/api/admin/discount-code/toggle-visible",
        type: "POST",
        data: ko.toJSON({
          visible: visible,
          discount_code_uuid: self.discount_code_uuid(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.visible(visible);

            notyf.success("Toggled!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);
    self.editing_extra_notes = ko.observable(false);
    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/discount-code/extra-notes",
        type: "POST",
        data: ko.toJSON({
          discount_code_uuid: self.discount_code_uuid(),
          extra_notes: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.extra_notes);
            self.new_extra_notes(data.extra_notes);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.lookup_redeemed_invoices = function () {
      // we need to add in a filter as well..
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/discount-code/invoices",
        type: "GET",
        data: {
          discount_code_uuid: self.discount_code_uuid(),
        },

        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.redeemed_invoices(
            ko.utils.arrayMap(
              data.discount_code.redeemed_invoices || [],
              function (x) {
                x.rootvm = self.rootvm;
                return new Invoice(x);
              }
            )
          );
        },
        error: function (data) {
          self.error(data.statusText);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };
  }
}
